var _ellipse, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0005,
    cy: 12,
    rx: 12,
    ry: 12,
    transform: "rotate(-180 12.0005 12)",
    fill: "#FF9356"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 0C10.4246 -1.8792e-08 8.86419 0.310389 7.40829 0.913446C5.95238 1.5165 4.62951 2.40042 3.51521 3.51472C2.4009 4.62902 1.51699 5.95189 0.913933 7.4078C0.310877 8.86371 0.000488043 10.4241 0.000488281 12L12.0005 12V0Z",
    fill: "url(#paint0_linear_226_1133)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 24C13.5764 24 15.1368 23.6896 16.5927 23.0866C18.0486 22.4835 19.3715 21.5996 20.4858 20.4853C21.6001 19.371 22.484 18.0481 23.087 16.5922C23.6901 15.1363 24.0005 13.5759 24.0005 12L12.0005 12L12.0005 24Z",
    fill: "url(#paint1_linear_226_1133)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_226_1133",
    x1: -0.924368,
    y1: 19.6627,
    x2: 17.1254,
    y2: 26.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_226_1133",
    x1: -0.924368,
    y1: 19.6627,
    x2: 17.1254,
    y2: 26.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6913"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.46fb32cb538e782e345ce4a6a940210e.svg";
export { ForwardRef as ReactComponent };